import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryBulky = () => {
  return <CategoryBase baseEndpoint="category_bulky" />;
};

export default CategoryBulky;
